<template>
  <div>
    <md-card>
      <md-card-header>
        <md-avatar>
          <img :src="profile.profileImg" alt="Avatar">
        </md-avatar>

        <md-card-header-text>
          <div class="md-title">{{ profile.fullName }}</div>
          <div class="md-subhead">{{ profile.description || "Descrição" }}</div>
          <!-- <div class="md-subhead">Amigos</div> -->
        </md-card-header-text>
      </md-card-header>

      <md-card-actions>
        <md-button class="md-primary md-raised" :to="{ name: 'profile', params: { id: profile.id } }">Ver perfil</md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
export default {
  props: ["profile"],
}
</script>

<style scoped>
</style>
